"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _orgGroup = require("@/api/auth/orgGroup");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 水波纹指令
var _default = exports.default = {
  name: 'addOrEditOrgGroupDialog',
  directives: {
    waves: _waves.default
  },
  props: ["addOrEditData"],
  data: function data() {
    return {
      textMap: {
        "create": this.$t('buttons.add'),
        // 添加
        "update": this.$t('buttons.update') // 更新
      },
      orgGroupData: {
        orgGroupId: null,
        orgGroupCode: null,
        orgGroupName: null
      },
      rules: {
        // 请填写名称 1-30字母数字中文
        orgGroupCode: [{
          required: true,
          message: this.$t('placeholder.Please130AlChinese'),
          trigger: 'blur'
        }],
        // 请填写Code,1-60 字母数字
        orgGroupName: [{
          required: true,
          message: this.$t('placeholder.Please160AlpCode'),
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {},
  watch: {
    'addOrEditData.orgGroupId': {
      handler: function handler(newValue, oldValue) {
        if (newValue === null) {
          return;
        }
        this.getOrgGroupData();
      },
      immediate: true // 代表在wacth里声明了firstName这个方法之后立即先去执行handler方法
    }
  },
  methods: {
    getOrgGroupData: function getOrgGroupData() {
      var _this = this;
      //获取当前组织角色
      var orgGroupId = this.addOrEditData.orgGroupId;
      (0, _orgGroup.getOrgGroupById)(orgGroupId).then(function (response) {
        var data = response.data;
        _this.orgGroupData.orgGroupId = data.orgGroupId;
        _this.orgGroupData.orgGroupCode = data.orgGroupCode;
        _this.orgGroupData.orgGroupName = data.orgGroupName;
      });
    },
    createData: function createData() {
      var _this2 = this;
      //创建组织角色
      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          (0, _orgGroup.createOrgGroup)(_this2.orgGroupData).then(function (response) {
            //刷新 列表  关闭 弹框
            _this2.addOrEditData.visible = false;
            _this2.$notify({
              title: _this2.$t('prompts.success'),
              message: _this2.$t('prompts.CreatedSucc'),
              type: 'success',
              duration: 3000
            });
            //重新加载
            _this2.$emit('refresh');
          });
        }
      });
    },
    updateData: function updateData() {
      var _this3 = this;
      //更新组织角色
      this.$refs['dataForm'].validate(function (valid) {
        if (valid) {
          (0, _orgGroup.updateOrgGroup)(_this3.orgGroupData).then(function (response) {
            //刷新 列表  关闭 弹框
            _this3.addOrEditData.visible = false;
            _this3.$notify({
              title: _this3.$t('prompts.success'),
              message: _this3.$t('prompts.SuccUpdate'),
              type: 'success',
              duration: 3000
            });

            //重新加载
            _this3.$emit('refresh');
          });
        }
      });
    }
  }
};